"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftPreferencesDto = instanceOfShiftPreferencesDto;
exports.ShiftPreferencesDtoFromJSON = ShiftPreferencesDtoFromJSON;
exports.ShiftPreferencesDtoFromJSONTyped = ShiftPreferencesDtoFromJSONTyped;
exports.ShiftPreferencesDtoToJSON = ShiftPreferencesDtoToJSON;
exports.ShiftPreferencesDtoToJSONTyped = ShiftPreferencesDtoToJSONTyped;
const ShiftTime_1 = require("./ShiftTime");
/**
 * Check if a given object implements the ShiftPreferencesDto interface.
 */
function instanceOfShiftPreferencesDto(value) {
    if (!('maximumTravelDistanceMiles' in value) || value['maximumTravelDistanceMiles'] === undefined)
        return false;
    if (!('minimumPayRate' in value) || value['minimumPayRate'] === undefined)
        return false;
    if (!('preferredShifts' in value) || value['preferredShifts'] === undefined)
        return false;
    return true;
}
function ShiftPreferencesDtoFromJSON(json) {
    return ShiftPreferencesDtoFromJSONTyped(json, false);
}
function ShiftPreferencesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'maximumTravelDistanceMiles': json['maximumTravelDistanceMiles'],
        'minimumPayRate': json['minimumPayRate'],
        'preferredShifts': (json['preferredShifts'].map(ShiftTime_1.ShiftTimeFromJSON)),
    };
}
function ShiftPreferencesDtoToJSON(json) {
    return ShiftPreferencesDtoToJSONTyped(json, false);
}
function ShiftPreferencesDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'maximumTravelDistanceMiles': value['maximumTravelDistanceMiles'],
        'minimumPayRate': value['minimumPayRate'],
        'preferredShifts': (value['preferredShifts'].map(ShiftTime_1.ShiftTimeToJSON)),
    };
}
//# sourceMappingURL=ShiftPreferencesDto.js.map